import { ResidentialStatus } from '../../../shared/models/enums/residential-status.enum';
import { Title } from '../../../shared/models/enums/title.enum';
import { DiagnosticBarrierDto } from './diagnostic-details/diagnosticBarrierDto';
import { DiagnosticQualificationDto } from './diagnostic-details/diagnosticQualificationDto';

export class DiagnosticInit {
  constructor(
    public beginDateOrientation: Date,
    public title: Title,
    public usualName: string,
    public firstName: string,
    public birthDate: Date,
    public address: string,
    public additionalAddress: string,
    public city: string,
    public postalCode: string,
    public residentialStatus: ResidentialStatus,
    public residentialStatusComplement: string,
    public maritalStatus: string,
    public jobCenterRegistration: boolean,
    public RSA: boolean,
    public RQTH: boolean,
    public degreeId: number,
    public degreeLabel: string,
    public drivingLicense: boolean,
    public drivingLicenses: DiagnosticQualificationDto[] = [],
    public barriers: DiagnosticBarrierDto[] = [],
    public structureId: number,
    public structureLabel: string,
    public structureAddress: string,
    public structureAdditionalAddress: string,
    public structureCity: string,
    public structurePostalCode: string,
    public structurePhone: string,
    public referentId: number,
    public referentName: string,
    public referentPhone: string,
  ) {}

  public static fromJson(json: any): DiagnosticInit {
    if (json) {
      return new DiagnosticInit(
        json.beginDateOrientation ? new Date(json.beginDateOrientation) : undefined,
        json.title,
        json.usualName,
        json.firstName,
        json.birthDate ? new Date(json.birthDate) : undefined,
        json.address,
        json.additionalAddress,
        json.city,
        json.postalCode,
        json.residentialStatus,
        json.residentialStatusComplement,
        json.maritalStatus,
        json.jobCenterRegistration,
        json.RSA,
        json.RQTH,
        json.degreeId,
        json.degreeLabel,
        json.drivingLicense,
        json.drivingLicenses && Array.isArray(json.drivingLicenses) ? json.drivingLicenses.map(DiagnosticQualificationDto.fromJson) : [],
        json.barriers && Array.isArray(json.barriers) ? json.barriers.map(DiagnosticBarrierDto.fromJson) : [],
        json.structureId,
        json.structureLabel,
        json.structureAddress,
        json.structureAdditionalAddress,
        json.structureCity,
        json.structurePostalCode,
        json.structurePhone,
        json.referentId,
        json.referentName,
        json.referentPhone,
      );
    }
  }
}
